export const analyzeContractText = async (text, agreementTypeId, agreementTypeValue) => {
  const res = await fetch('https://triunityiq.com/api.php/analyze-text', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      agreement_id: agreementTypeId,
      agreement_type: agreementTypeValue,
      text: text,
    }),
  });

  const json = await res.json();
  if (json.status === 1) {
    return json;
  } else {
    throw new Error(json.msg || 'Failed to analyze text');
  }
};